import INVENTORY_API_BASE_URL from "../../config/api";
import React, { useState, useEffect } from "react";
import axios from "axios";
import styles from "./extrabar.module.css";

const BatchSearch = () => {
  const [selectedOption, setSelectedOption] = useState("");
  const [results, setResults] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      if (!selectedOption) return;

      try {
        const response = await axios.get(`${INVENTORY_API_BASE_URL}/search-batch?text=${encodeURIComponent(selectedOption)}`);
        setResults(response.data.reverse());
      } catch (error) {
        console.error("Error fetching batch data:", error);
        setResults([]);
      }
    };

    fetchData();
  }, [selectedOption]);

  const getHeaderLabel = () => {
    if (selectedOption === "From Shivalik") return "Batch ID";
    if (selectedOption === "Return from Distributors") return "GRN No.";
    return "ID";
  };

  return (
    <div className={styles.container}>
      <main className={styles.workspace}>
        <header className={styles.header}>
          <div>
            <span className={styles.eyebrow}>Inventory / Batch records</span>
            <h1 className={styles.heading}>Extra barcode records</h1>
            <p className={styles.intro}>
              Review additional barcodes recorded against incoming and returned batches.
            </p>
          </div>
          <span className={styles.headerBadge}>
            <span aria-hidden="true" />
            Batch lookup
          </span>
        </header>

        <section className={styles.overview} aria-label="Batch search summary">
          <article className={styles.statCard}>
            <span className={styles.statMark} aria-hidden="true">01</span>
            <div>
              <span className={styles.statLabel}>Records found</span>
              <strong>{results.length}</strong>
              <small>Rows in the current selection</small>
            </div>
          </article>
          <article className={styles.statCard}>
            <span className={styles.statMark + " " + styles.statMarkSource} aria-hidden="true">02</span>
            <div>
              <span className={styles.statLabel}>Selected source</span>
              <strong className={styles.statValue}>{selectedOption || "—"}</strong>
              <small>{selectedOption ? "Source records are shown below" : "Choose a source to begin"}</small>
            </div>
          </article>
          <article className={styles.statCard}>
            <span className={styles.statMark + " " + styles.statMarkStatus} aria-hidden="true">03</span>
            <div>
              <span className={styles.statLabel}>Lookup status</span>
              <strong className={styles.statValue}>{selectedOption ? "Ready" : "Awaiting source"}</strong>
              <small>Choose incoming stock or distributor returns</small>
            </div>
          </article>
        </section>

        <section className={styles.panel} aria-label="Extra barcode batch records">
          <div className={styles.panelHeader}>
            <div>
              <span className={styles.sectionEyebrow}>Batch search</span>
              <h2>Extra barcode register</h2>
              <p>Select a record source to load its batch totals.</p>
            </div>
            <span className={styles.resultCount}>
              {selectedOption
                ? results.length + " " + (results.length === 1 ? "RECORD" : "RECORDS")
                : "SELECT A SOURCE"}
            </span>
          </div>

          <div className={styles.selector}>
            <label htmlFor="batch-search-source">Record source</label>
            <select
              id="batch-search-source"
              value={selectedOption}
              onChange={(e) => setSelectedOption(e.target.value)}
              className={styles.dropdown}
            >
              <option value="">Choose a source</option>
              <option value="From Shivalik">From Shivalik</option>
              <option value="Return from Distributors">Return from Distributors</option>
            </select>
          </div>

          {results.length > 0 ? (
            <div className={styles.tableWrap}>
              <table className={styles.table}>
                <thead>
                  <tr>
                    <th scope="col">{getHeaderLabel()}</th>
                    <th scope="col">Extra barcodes count</th>
                  </tr>
                </thead>
                <tbody>
                  {results.map((item, idx) => (
                    <tr key={idx}>
                      <td data-label={getHeaderLabel()}>
                        <span className={styles.batchId}>{item.batchId}</span>
                      </td>
                      <td data-label="Extra barcodes count">
                        <span className={styles.barcodeCount}>{item.arrayCount}</span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className={styles.emptyState}>
              <span className={styles.emptyMark} aria-hidden="true">{selectedOption ? "0" : "01"}</span>
              <strong>{selectedOption ? "No batch records found" : "Choose a source to begin"}</strong>
              <span>
                {selectedOption
                  ? "There are no extra barcode records for this source."
                  : "Select a source above to view extra barcode totals by batch."}
              </span>
            </div>
          )}

          <footer className={styles.panelFooter}>
            {selectedOption
              ? "Showing " + results.length + " " +
                (results.length === 1 ? "batch record" : "batch records") +
                " for " + selectedOption
              : "Select a source to display its batch records."}
          </footer>
        </section>
      </main>
    </div>
  );
};

export default BatchSearch;
